import { Api } from './Api'

class Invoice {
  getPromise (ocr, signal = null) {
    return fetch(`${Api.getBaseUrl()}invoice/${ocr}`, Api.getOptions('GET', {}, signal))
  }
}

export default Invoice
